"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NedChevron = exports.OppChevron = exports.VenstreChevron = exports.HoyreChevron = void 0;
const PT = __importStar(require("prop-types"));
const React = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
require("nav-frontend-chevron-style");
// export type ChevronType = 'høyre' | 'venstre' | 'ned' | 'opp';
const cls = (type, stor, className) => (0, classnames_1.default)("nav-frontend-chevron chevronboks", className, {
    "chevron--stor": stor,
}, {
    "chevron--hoyre": type === "høyre",
    "chevron--venstre": type === "venstre",
    "chevron--ned": type === "ned",
    "chevron--opp": type === "opp",
});
class NavFrontendChevron extends React.Component {
    render() {
        const _a = this.props, { type, stor, className } = _a, props = __rest(_a, ["type", "stor", "className"]);
        return React.createElement("span", Object.assign({ className: cls(type, stor, className) }, props));
    }
}
NavFrontendChevron.defaultProps = {
    type: "høyre",
    stor: false,
    className: "",
};
NavFrontendChevron.propTypes = {
    /**
     * Bestemmer hvilken vei Chevron skal peke
     */
    type: PT.oneOf(["høyre", "venstre", "opp", "ned"]),
    /**
     * Sett denne proppen hvis chevron skal være stor
     */
    stor: PT.bool,
    /**
     * Klassenavn for chevron
     */
    className: PT.string,
};
exports.default = NavFrontendChevron;
var hoyre_chevron_1 = require("./hoyre-chevron");
Object.defineProperty(exports, "HoyreChevron", { enumerable: true, get: function () { return __importDefault(hoyre_chevron_1).default; } });
var venstre_chevron_1 = require("./venstre-chevron");
Object.defineProperty(exports, "VenstreChevron", { enumerable: true, get: function () { return __importDefault(venstre_chevron_1).default; } });
var opp_chevron_1 = require("./opp-chevron");
Object.defineProperty(exports, "OppChevron", { enumerable: true, get: function () { return __importDefault(opp_chevron_1).default; } });
var ned_chevron_1 = require("./ned-chevron");
Object.defineProperty(exports, "NedChevron", { enumerable: true, get: function () { return __importDefault(ned_chevron_1).default; } });
